import Provider from '../Provider/Provider'
import PlanPrices from '../PlanPrices/PlanPrices'
import Chevron from '../Chevron/Chevron'
import { GRAYSCALE_400 } from '../../styles/colors'
import * as S from './PlanOption.styles'

export type PlanOptionProps = {
  providerIconUrl: string
  title: string
  description: string
  idr: number
}

export default function PlanOption({
  providerIconUrl,
  title,
  description,
  idr
}: PlanOptionProps) {
  return (
    <S.Container>
      <S.TopSection>
        <S.ProviderRow>
          <S.ContentContainer>
            <S.Title>{title}</S.Title>
            <S.Description>{description}</S.Description>
          </S.ContentContainer>
          <Provider iconUrl={providerIconUrl} imageHeight={24} imageWidth={42} width={42} height={24} padding={4} />
        </S.ProviderRow>
      </S.TopSection>
      <S.BottomSection>
        <PlanPrices idr={idr} />
        <Chevron direction="right" color={GRAYSCALE_400} size={6} strokeWidth={2} />
      </S.BottomSection>
    </S.Container>
  )
}
